// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rA0m","content":"styles_content__1xAJM","row":"styles_row__3HTw7","footer":"styles_footer__1JQrQ","phraseLength":"styles_phraseLength__2ZZHX"};